export enum AccountType {
	PRIMARY = 1,
	SOCIAL,
	ADMIN
}

export interface User {
	_id: string;
	firstName: string;
	lastName: string;
	email: string;
	email_verified: boolean;
	email_verify_count: number;
	account_type: number;
	guide_completed: boolean;
}

export interface ISignUp {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	confirmPassword?: string;
	recaptchaToken?: string;
}

export interface ILoginIn {
	email: string;
	password: string;
	recaptchaToken?: string;
}
